import { ChangeDetectorRef, Injectable } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { DataConnectorType, DataConnector, FileDataConnector, FtpServerType, FtpService } from 'src/app/domainObjects/dataConnector';
import { DataSourceType } from 'src/app/domainObjects/dataSourceType';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';
import { FileBrowserDialogComponent } from 'src/app/views/file-browser-dialog/file-browser-dialog.component';
import { DataConnectorViewModel } from 'src/app/viewModels/dataConnectorViewModel';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { ConfigService } from 'src/app/services/config/config.service';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'src/app/services/shared.service';
import { UserDataService } from 'src/app/services/user-data-service';
// import { IngestParametersSetting, IngestParametersSettings } from 'src/app/domainObjects/masterConfig';
import { FolderBrowserDialogComponent } from 'src/app/views/folder-browser-dialog/folder-browser-dialog.component';
import { DatePipe } from '@angular/common';
import { UpdateingestnodestatusService } from 'src/app/services/updateingestnodestatus.service';
import { DetectDelimiterRequest } from 'src/app/messaging/detectDelimiterRequest';
import { FtpConnectionStatus, ftpNotReadyMessage } from 'src/app/views/shared/ftp-service-select/ftp-service-select.component';

export class FileDataConnectorViewModel extends DataConnectorViewModel<FileDataConnector> {
  id: number;
  // inputFileName = '';
  fileNameFormat = '';
  // delimiter = '';
  delimiters = ['|', ',', '[tab]','~'];
  scheduleDelimiter='';
  connectionTimeOut: number;
  scheduleConnectionTimeOut='';
  inputFileNameFileScheduleDirectory='';
  baseFileName='';
  dateTimeExtension: string = '';  // Date-Time extension
  selectedInstance= '';
  nValue= '';
  currentDate: string;  // Holds the current date in YYYY-MM-DD format
  fileExtension='';

  constructor(fileDataConnector?: FileDataConnector) {
    super();
    this.dataConnectorType = DataConnectorType.Text;
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; // Extracts the date part in YYYY-MM-DD format
   
     // Set the defualt values
     this.scheduleConnectionTimeOut="180"
     this.scheduleDelimiter='';
     this.baseFileName='';
     this.dateTimeExtension = 'yyyy-MM-dd';  // Set the current date as default
     this.nValue='';
     this.fileExtension='.csv';
     this.isUseFtp =false;
     this.ftpService = new FtpService(FtpServerType.SFTP,"","","", 22);
    if (fileDataConnector) {
      this.inputFileName = fileDataConnector.filePath;
      this.fileNameFormat = fileDataConnector.fileNameFormat;
      this.delimiter = fileDataConnector.delimiter;
      this.id = fileDataConnector.id;
      this.connectionTimeOut = fileDataConnector.connectionTimeOut;
      this.selectedInstance=fileDataConnector.selectedInstance;
      this.nValue=fileDataConnector.nValue;
      this.isUseFtp = fileDataConnector.isUseFtp;
      this.ftpService = fileDataConnector.ftpService;
    }
   


  }

  toDataConnector(): FileDataConnector {
    return new FileDataConnector(this.id, this.inputFileName, this.fileNameFormat, this.delimiter, this.connectionTimeOut,this.selectedInstance,this.nValue,this.isUseFtp,this.ftpService);
  }
}

@Component({
    selector: 'app-file-data-connector',
    templateUrl: './file-data-connector.component.html',
    styleUrls: ['./file-data-connector.component.css'],
    standalone: false
})

// @Injectable({
//   providedIn: 'root'
// })

export class FileDataConnectorComponent extends BaseComponent implements OnInit {
  @Input() dataSourceType: DataSourceType;
  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;
  //@Input() viewModel: FileDataConnectorViewModel;
  isLoading = new BehaviorSubject<boolean>(false);
  
  // myControl = new UntypedFormControl('');
  delimiterOptions: Observable<string[]>;
  formattedDate: string;
  selectedFormat: string = 'yyyy-MM-dd'; // Default format
  viewModel: FileDataConnectorViewModel;
  isInstanceDisabled:boolean;
  private subscription!: Subscription;
  
  constructor(
    private changeDet: ChangeDetectorRef, 
    private configService: ConfigService,
    private sharedService: SharedService,
    private userData: UserDataService,
    private updateingestnodestatusService: UpdateingestnodestatusService,
    matDialog: MatDialog,
    private snackBar: MatSnackBar,
    public datePipe: DatePipe,
    errorLogger: ErrorReportingService) {
      super(errorLogger, matDialog);
      this.isInstanceDisabled= false;
    }

    // filePath:IngestParametersSetting;
    updateDate() {
      const currentDate = new Date();
      this.formattedDate = this.datePipe.transform(currentDate, this.selectedFormat) || '';
    }
       // Call this method when format changes
       onFormatChange(newFormat: string) {
        this.selectedFormat = newFormat;
        this.updateDate();
      }
  ngOnInit(): void {

    // const selectedNode=this.userData.getSelectedNodeDetails();
    console.log("oninit delimiter====",this.viewModel.delimiter);
    this.updateDate();
    /*const connectorTypeData=this.userData.getIngestConnectorData()
    console.log("connectorTypeData prajna====",connectorTypeData); 
    const masterconfig=this.userData.getIngestConnectorData().find(x=>x.id==0);
    console.log("masterconfig prajna====",masterconfig);
    //var params=masterconfig.parameters;
    //console.log("params prajna====",params);
    
    var params=masterconfig.parameters.find(x=>x.connectortypeid==1).parameters;
    console.log("params====",params);
    this.filePath=params.find(x=>x.jsonobject=='filePath');
    console.log("this.filePath====",this.filePath);*/
    this.subscription = this.sharedService.getEvent().subscribe(data => {
      // console.log('Received event in Child One:', data);
      this.changeDet.detectChanges();
      // Handle the event data here
    });
    // this.viewModel = this.ingestConfigViewModel.dataConnector;
    //this.importSetupViewModel.fileDataConnectorViewModel = this.viewModel;
    // this.delimiterOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value || '')),
    // );
    console.log("oninit delimiter====",this.viewModel.delimiter);
    if(!this.viewModel.ftpService){
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe(); // Clean up to avoid memory leaks
  }
  private _filter(value: string): string[] {

    return this.viewModel.delimiters.filter(delimiter => delimiter.includes(value));
  }

  ngOnChanges(changes: any) {
    this.viewModel = changes.ingestConfigViewModel?.currentValue.getFileDataConnector();
    if (!this.viewModel || this.viewModel.dataConnectorType!=DataConnectorType.Text) {
      this.viewModel = new FileDataConnectorViewModel();
      this.viewModel.ftpService=new FtpService(FtpServerType.SFTP,"","","", 22);
      this.viewModel.dataSourceType = this.dataSourceType;
      this.ingestConfigViewModel.dataConnector = this.viewModel;
      
    } else {

    }
  }

  /** Connection test state of the selected FTP service; FTP browsing waits for 'success'. */
  ftpConnectionStatus: FtpConnectionStatus = 'none';

  onFtpChange(updated: FtpService) {
    this.viewModel.ftpService = updated;
  }

  handleBlur(value: string) {
    console.log('Input field lost focus. Current value:', value);
    this.changeDet.detectChanges();
    if(value)
    {  this.detectDelimiter( value);}
  }

  showFileBrowserDialog(): void {
    const ftpNotReady = ftpNotReadyMessage(this.viewModel.isUseFtp, this.ftpConnectionStatus);
    if (ftpNotReady) {
      this.displayError(ftpNotReady, 'FTP Service');
      return;
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    console.log("showFileBrowserDialog this.viewModel.dataConnectorTypes",this.viewModel.dataConnectorType);
    dialogConfig.data = {dataSourceTypeId: this.dataSourceType, supportedFileTypes: ['.csv', '.txt'],isUseFtp:this.viewModel.isUseFtp,ftpService:this.viewModel.ftpService, ingestFilePath:this.viewModel.inputFileName, ingestDataConnectorType: this.viewModel.dataConnectorType};

    const dialogRef = this.matDialog.open(FileBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      //console.log('User selected to import file: ' + result.selectedFileName);
      const previousFileName = this.viewModel.inputFileName;
      this.viewModel.inputFileName = result.selectedFileName;

      // TODO: Determine why I need to invoke the below code to get UI reflecting the inputFileName
      this.changeDet.detectChanges();
      this.detectDelimiter( result.selectedFileName);

      if (this.ingestConfigViewModel.hasMappedSourceChanged(previousFileName, result.selectedFileName)) {
        // The old Column Map refers to the previous file's columns — clear it and let the
        // Analyst know right away that it needs to be reconfigured.
        this.ingestConfigViewModel.columnMap = [];
      }
      if (this.ingestConfigViewModel.columnMap.length === 0) {
        this.displayWarning(
          'Please configure the Column Mapper before saving.',
          'Column Mapper Not Configured',
          null,
          () => {
            this.sharedService.sendEvent({ type: 'open_mapper_panel', guid: this.ingestConfigViewModel.guid });
          }
        );
        return;
      }
    });
  }
  browseDir(){
    //console.log("browseDir....",fieldname);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '750px';
    dialogConfig.data = {dataSourceTypeId: 1, supportedFileTypes: ['.csv', '.txt']};

    const dialogRef = this.matDialog.open(FolderBrowserDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result.selectedFileName) { return; }

      // File chosen is
      //console.log('User selected to import file: ' + result.selectedFileName);
      this.viewModel.inputFileNameFileScheduleDirectory= result.selectedFileName;
       // Focus back to the input field if necessary
     // Focus back to the input field if necessary

    //  this.formGroup[fieldname] = new FormControl(result.selectedFileName);
      //this.form = this.formBuilder.group(this.formGroup);
       // Ensure the input field regains focus
        this.changeDet.detectChanges();
    });
  }
  /*async detectDelimiter(path): Promise<void> {
    const busyDialog = this.showBusyDialog('Detecting Delimiter...');
    try {
      
      const response = await this.configService.detectDelimiterAsync(path);

      console.log("response delimiter",response);
      
      if(response.delimiter==""){
        this.snackBar.open('No Field Delimiter was found, please enter manually', 'Dismiss', {
          duration: 5000
        });
      }else{
        var delimiterName=""
        if(response.delimiter=="|"){
          delimiterName="pipe";
        }else if(response.delimiter==","){
          delimiterName="comma";
        }else if(response.delimiter=="[tab]"){
          delimiterName="tab";
        }
        this.snackBar.open('The Field Delimiter '+response.delimiter+' ('+delimiterName+') was found and selected', 'Dismiss', {
          duration: 5000
        });
      }
      this.viewModel.delimiter = response.delimiter;
      this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
      this.changeDet.detectChanges();
    } catch (err) {
      this.displayError('Failed to get delimiter', 'Error', err, (result) => {
      });
    } finally {
      busyDialog.close();
    }
  }*/

    async detectDelimiter(path): Promise<void> {
      const busyDialog = this.showBusyDialog('Detecting Delimiter...');
      try {
        const request = new DetectDelimiterRequest(
            path,
            this.viewModel.isUseFtp,
            this.viewModel.ftpService
          );
        const response = await this.configService.detectDelimiterAsync(request);
  
       // console.log("response delimiter",response);
        
        if(response.delimiter==""){
          this.snackBar.open('No Field Delimiter was found, please enter manually', 'Dismiss', {
            duration: 5000
          });
        }else{
          var delimiterName=""
          if(response.delimiter=="|"){
            delimiterName="pipe";
          }else if(response.delimiter==","){
            delimiterName="comma";
          }else if(response.delimiter=="[tab]"){
            delimiterName="tab";
          }
          this.snackBar.open('The Field Delimiter '+response.delimiter+' ('+delimiterName+') was found and selected', 'Dismiss', {
            duration: 5000
          });
        }
        this.viewModel.delimiter = response.delimiter;
        // this.updateingestnodestatusService.invokeUpdateIngestNodeStatus();
        this.changeDet.detectChanges();
      }catch (err) {
        console.error('Delimiter detection error:', err);
    
    // Extract errorType from backend error structure
    const errorType = err?.error?.errorMessage?.[0]?.exc_obj?.errorType;
    const backendMessage = err?.error?.errorMessage?.[0]?.exc_obj?.errorMessage;
    //console.log("errorType==",errorType);

    if (errorType === 'FileNotFoundError') {
      this.displayError("The file or file path of the Developer File Path was not found or incorrectly entered.", "File or File path not found");  
      this.viewModel.inputFileName='';
      this.changeDet.detectChanges();
    
    } else {
      this.displayError('Failed to get delimiter', 'Error', err, (result) => {});
    }
      }  finally {
        busyDialog.close();
      }
    }
  handleBlurDirectory(inputFileNameExcel: string) {
    setTimeout(() => {
      // Your logic to handle the blur event
      console.log('Directory:', inputFileNameExcel);
    }, 200);
  }

    onSelectionChange(selectedValue: string) {
      if (selectedValue === 'first') {
        this.viewModel.nValue = '1';
        this.isInstanceDisabled = true;  // Freeze the instance field
      } else if (selectedValue === 'nth') {
        this.viewModel.nValue = '1'; // Keep it blank for nth
        this.isInstanceDisabled = false;  // Freeze the instance field
      } else {
        this.viewModel.nValue = ''; // Keep it blank for nth
        this.isInstanceDisabled = true;  // Freeze the instance field
      }
    }
}
